// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__pug4O","actionsCol":"EnrolledClinics_actionsCol__38n7y"};